import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FallbackImage } from "@/components/common/FallbackImage";
interface WavePictureProps {
  readonly name: string;
  readonly picture: string | null;
  readonly contributors: {
    readonly pfp: string;
  }[];
}
const polygonsByCount: Record<number, string[]> = {
  // 1 entire area
  1: ["polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"],
  // 2 halves: left, right
  2: ["polygon(0% 0%, 50% 0%, 50% 100%, 0% 100%)",
  // left
  "polygon(50% 0%, 100% 0%, 100% 100%, 50% 100%)" // right
  ],
  // 3 horizontal strips: top, middle, bottom
  3: ["polygon(0% 0%, 100% 0%, 100% 33.33%, 0% 33.33%)",
  // top
  "polygon(0% 33.33%, 100% 33.33%, 100% 66.66%, 0% 66.66%)",
  // middle
  "polygon(0% 66.66%, 100% 66.66%, 100% 100%, 0% 100%)" // bottom
  ],
  // 4 quadrants
  4: ["polygon(0% 0%, 50% 0%, 50% 50%, 0% 50%)",
  // top-left
  "polygon(50% 0%, 100% 0%, 100% 50%, 50% 50%)",
  // top-right
  "polygon(0% 50%, 50% 50%, 50% 100%, 0% 100%)",
  // bottom-left
  "polygon(50% 50%, 100% 50%, 100% 100%, 50% 100%)" // bottom-right
  ],
  // 5 horizontal strips (each 20% height)
  5: ["polygon(0% 0%, 100% 0%, 100% 20%, 0% 20%)", "polygon(0% 20%, 100% 20%, 100% 40%, 0% 40%)", "polygon(0% 40%, 100% 40%, 100% 60%, 0% 60%)", "polygon(0% 60%, 100% 60%, 100% 80%, 0% 80%)", "polygon(0% 80%, 100% 80%, 100% 100%, 0% 100%)"],
  // 6 => 2 rows × 3 columns each
  6: [
  // top-left
  "polygon(0% 0%, 33.33% 0%, 33.33% 50%, 0% 50%)",
  // top-middle
  "polygon(33.33% 0%, 66.66% 0%, 66.66% 50%, 33.33% 50%)",
  // top-right
  "polygon(66.66% 0%, 100% 0%, 100% 50%, 66.66% 50%)",
  // bottom-left
  "polygon(0% 50%, 33.33% 50%, 33.33% 100%, 0% 100%)",
  // bottom-middle
  "polygon(33.33% 50%, 66.66% 50%, 66.66% 100%, 33.33% 100%)",
  // bottom-right
  "polygon(66.66% 50%, 100% 50%, 100% 100%, 66.66% 100%)"]
};
export default function WavePicture(t0) {
  const $ = _c(13);
  const {
    name,
    picture,
    contributors
  } = t0;
  if (picture) {
    let t1;
    if ($[0] !== name || $[1] !== picture) {
      t1 = <div className="tw-w-full tw-h-full tw-relative tw-rounded-full tw-overflow-hidden"><FallbackImage primarySrc={picture} fallbackSrc={picture} alt={name} fill={true} sizes="64px" className="tw-object-cover" /></div>;
      $[0] = name;
      $[1] = picture;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  let t2;
  let t3;
  if ($[3] !== contributors) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const pfps = contributors.map(_temp).filter(Boolean);
      if (pfps.length === 0) {
        let t4;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <div className="tw-w-full tw-h-full tw-bg-gradient-to-br tw-from-iron-800 tw-to-iron-700 tw-rounded-full" />;
          $[7] = t4;
        } else {
          t4 = $[7];
        }
        t3 = t4;
        break bb0;
      }
      const sliceCount = Math.min(pfps.length, 6);
      const polygons = polygonsByCount[sliceCount];
      t1 = "tw-relative tw-w-full tw-h-full";
      let t4;
      if ($[8] !== polygons) {
        t4 = (pfp, i) => {
          const clip = polygons[i];
          return <div key={pfp + i} className="tw-absolute tw-inset-0" style={{
            clipPath: clip
          }}><FallbackImage primarySrc={pfp} fallbackSrc={pfp} alt={`Contributor-${i}`} fill={true} sizes="64px" className="tw-object-cover tw-block tw-rounded-full" /></div>;
        };
        $[8] = polygons;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      t2 = pfps.slice(0, sliceCount).map(t4);
    }
    $[3] = contributors;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2) {
    t4 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(c) {
  return c.pfp;
}